import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.67 8.708a.7.7 0 0 1-.595.792c-1.294.184-2.35.48-3.06.827-.356.174-.593.345-.732.491-.135.143-.141.223-.141.244v7.778c0 .026.016.168.32.403.295.227.766.461 1.41.67 1.28.418 3.094.687 5.128.687 2.034 0 3.847-.27 5.128-.686.644-.21 1.115-.444 1.41-.671.304-.235.32-.377.32-.403v-7.778c0-.02-.006-.1-.141-.244-.139-.146-.375-.317-.732-.49-.71-.347-1.766-.644-3.06-.828a.7.7 0 0 1 .197-1.386c1.375.195 2.587.521 3.477.955.444.217.84.476 1.135.787.298.316.524.723.524 1.206v7.778c0 .653-.406 1.158-.867 1.512-.47.362-1.106.658-1.83.893-1.455.474-3.42.755-5.561.755-2.14 0-4.106-.281-5.561-.755-.724-.235-1.36-.53-1.83-.893-.46-.354-.867-.859-.867-1.512v-7.778c0-.483.226-.89.524-1.206.295-.311.691-.57 1.135-.787.89-.434 2.102-.76 3.477-.955a.7.7 0 0 1 .792.594Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.442 10.362a.7.7 0 0 1 .7.7c0 .026.016.169.32.403.295.227.766.462 1.41.671 1.28.417 3.094.686 5.128.686 2.034 0 3.847-.27 5.128-.686.644-.21 1.115-.444 1.41-.671.304-.234.32-.377.32-.403a.7.7 0 1 1 1.4 0c0 .654-.406 1.158-.867 1.513-.47.361-1.106.657-1.83.892-1.455.474-3.42.755-5.561.755-2.14 0-4.106-.281-5.561-.755-.724-.235-1.36-.53-1.83-.893-.46-.354-.867-.858-.867-1.512a.7.7 0 0 1 .7-.7ZM4.442 14.298a.7.7 0 0 1 .7.7c0 .027.016.169.32.403.295.227.766.462 1.41.671 1.28.417 3.094.687 5.128.687 2.034 0 3.847-.27 5.128-.687.644-.21 1.115-.444 1.41-.67.304-.235.32-.377.32-.404a.7.7 0 1 1 1.4 0c0 .654-.406 1.159-.867 1.513-.47.362-1.106.657-1.83.893-1.455.473-3.42.755-5.561.755-2.14 0-4.106-.282-5.561-.755-.724-.236-1.36-.531-1.83-.893-.46-.354-.867-.86-.867-1.513a.7.7 0 0 1 .7-.7Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M11.51 2.2a.7.7 0 0 1 .98 0l3.024 2.968a.7.7 0 0 1-.981.999l-1.833-1.8v6.424a.7.7 0 1 1-1.4 0V4.368L9.467 6.167a.7.7 0 1 1-.98-1L11.51 2.2Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
